module.exports = __webpack_public_path__ + "img/hardwareSettings.c6dabcdb.svg";